import { render, staticRenderFns } from "./OrganizerDashboard.vue?vue&type=template&id=5a6cd124&scoped=true&"
import script from "./OrganizerDashboard.vue?vue&type=script&lang=ts&"
export * from "./OrganizerDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizerDashboard.vue?vue&type=style&index=0&id=5a6cd124&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6cd124",
  null
  
)

export default component.exports